import styled from "styled-components";

export const IconWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.text.secondary.color};
  transition:
    background-color 0.3s,
    border 0.3s,
    box-shadow 0.3s;
`;

export const Wrapper = styled.span<{ $iconPosition: "left" | "right" }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === "left" ? "row-reverse" : "row"};
  cursor: pointer;

  &:hover {
    ${IconWrapper} {
      border: 1px solid ${({ theme }) => theme.colors.text.primary.color};
      box-shadow: 0px 0px 6px 0px rgba(255, 255, 255, 0.8);

      svg {
        color: ${({ theme }) => theme.colors.text.primary.color};
      }
    }
  }
`;

export const Label = styled.span`
  position: absolute;
  border: 1px solid ${({ theme }) => theme.colors.background.layers[400]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: 0 ${({ theme }) => theme.spacing[1]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
`;
